import React from "react";
import { Ad } from "../types";
import withRedux from "../withRedux";
import adSelector from "../selectors/adSelector";

const Sponsors = ({ ads }: { ads: Ad[]; resourceId?: string }) => {
	if (!ads || ads.length === 0) {
		return null;
	}
	return (
		<div className="sponsors">
			{ads.map((ad, index) => {
				if (ad.link) {
					return (
						<a
							href={ad.link}
							target="_blank"
							rel="noopener noreferrer"
							key={["ad", ad.name, index].join("_")}
						>
							<div className="item sponsor medium">
								<img className="itemImage" src={ad.mainPicture} alt="" />
							</div>
						</a>
					);
				} else {
					return (
						<div className="item sponsor medium" key={["ad", ad.name, index].join("_")}>
							<img className="itemImage" src={ad.mainPicture} alt="" />
						</div>
					);
				}
			})}
		</div>
	);
};

const mapStateToProps = ({ deals: { ads } }, ownProps) => {
	const { resourceId } = ownProps;
	return { ads: adSelector(ads, null, resourceId) };
};

export default withRedux({}, mapStateToProps)(Sponsors);
